export default __webpack_public_path__ + "static/general_cta-bg-2c81af8727928e7aa8598f2eb94c9c06.jpg";